import 'windi.css'
import SceneConfigureRoutes from './routes'

export default {
  name: 'scene-configure-vulkan',
  title: '场景配置5.0',
  version: '0.1.6',
  description: '三维场景配置5.0',
  routes: SceneConfigureRoutes, // 导出相关路由
  sysRoutes: [],
  dependencies: {
    apis: ['DirectoryApi', 'MaterialApi', 'FileApi', 'ModelSceneApi'],
  },
  config: {}
}
